export default "__VITE_ASSET__BWNU6Aqx__"